module.exports = __webpack_public_path__ + "static/media/truedreams.aaaf1543.jpg";